module.exports = __webpack_public_path__ + "mt.520506eac2f615ccd962.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mt.svg
// module chunks = styles